var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('br'),_c('h1',[_vm._v(_vm._s(_vm.$t('account.logout.title')))]),(_vm.success)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('account.logout.message'))+" ")]):_c('div',[_c('Loading')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }